import React, { createContext, useContext, useState, useEffect } from 'react';
import { preloadImages } from '../utils/preloadImages';
import AirForces from '../assets/images/types/airforce.gif';
import Arena from '../assets/images/types/arena.png';
import Artillery from '../assets/images/types/artillery.gif';
import Cavalry from '../assets/images/types/cavalry.gif';
import Civil from '../assets/images/types/civil.gif';
import Construction from '../assets/images/types/construction.gif';
import Exploration from '../assets/images/types/exploration.gif';
import Farm from '../assets/images/types/farm.png';
import Infantry from '../assets/images/types/infantry.gif';
import Lab from '../assets/images/types/lab.png';
import Library from '../assets/images/types/library.png';
import Military from '../assets/images/types/military.gif';
import Mine from '../assets/images/types/mine.png';
import Temple from '../assets/images/types/temple.png';
import Theater from '../assets/images/types/theater.png';

import BlueCube from '../assets/images/resources/blue.gif';
import YellowCube from '../assets/images/resources/yellow.gif';
import CivilAction from '../assets/images/resources/ca.gif';
import Culture from '../assets/images/resources/culture.png';
import ExplorationResource from '../assets/images/resources/exploration.png';
import Food from '../assets/images/resources/food.png';
import Happiness from '../assets/images/resources/happy.png';
import MilitaryAction from '../assets/images/resources/ma.gif';
import MissingCube from '../assets/images/resources/missing.gif'
import Resource from '../assets/images/resources/resource.png';
import Science from '../assets/images/resources/science.png';
import Strength from '../assets/images/resources/strength.png';
import Home from '../assets/images/home.gif';
import Corruption from '../assets/images/corruption.gif';
import Discard from '../assets/images/discard.gif';
import Unhappy from '../assets/images/unhappy.png';

// The same pictures redrawn as vector drawings, shown in their place with "Use new icons" (see Preferences.js). Each is
// the pixel size of the picture it replaces. The cavalry's horse is from SVG Repo.
import { useNewIcons } from '../utils/Preferences';
import NewAirForces from '../assets/icons/types/airforce.svg';
import NewArena from '../assets/icons/types/arena.svg';
import NewArtillery from '../assets/icons/types/artillery.svg';
import NewCavalry from '../assets/icons/types/cavalry.svg';
import NewCivil from '../assets/icons/types/civil.svg';
import NewConstruction from '../assets/icons/types/construction.svg';
import NewExploration from '../assets/icons/types/exploration.svg';
import NewFarm from '../assets/icons/types/farm.svg';
import NewInfantry from '../assets/icons/types/infantry.svg';
import NewLab from '../assets/icons/types/lab.svg';
import NewLibrary from '../assets/icons/types/library.svg';
import NewMilitary from '../assets/icons/types/military.svg';
import NewMine from '../assets/icons/types/mine.svg';
import NewTemple from '../assets/icons/types/temple.svg';
import NewTheater from '../assets/icons/types/theater.svg';
import NewBlueCube from '../assets/icons/resources/blue.svg';
import NewYellowCube from '../assets/icons/resources/yellow.svg';
import NewCivilAction from '../assets/icons/resources/ca.svg';
import NewCulture from '../assets/icons/resources/culture.svg';
import NewExplorationResource from '../assets/icons/resources/exploration.svg';
import NewFood from '../assets/icons/resources/food.svg';
import NewHappiness from '../assets/icons/resources/happy.svg';
import NewMilitaryAction from '../assets/icons/resources/ma.svg';
import NewMissingCube from '../assets/icons/resources/missing.svg';
import NewResource from '../assets/icons/resources/resource.svg';
import NewScience from '../assets/icons/resources/science.svg';
import NewStrength from '../assets/icons/resources/strength.svg';
import NewHome from '../assets/icons/home.svg';
import NewCorruption from '../assets/icons/corruption.svg';
import NewDiscard from '../assets/icons/discard.svg';
import NewUnhappy from '../assets/icons/unhappy.svg';


import Alexander from '../assets/images/Leaders/AlexanderTheGreat.jpg'
import Aristotle from '../assets/images/Leaders/Aristotle.jpg'
import Hammurabi from '../assets/images/Leaders/Hammurabi.jpg'
import Homer from '../assets/images/Leaders/Homer.jpg'
import Caesar from '../assets/images/Leaders/JuliusCaesar.jpg'
import Moses from '../assets/images/Leaders/Moses.jpg'
import Columbus from '../assets/images/Leaders/ChristopherColumbus.jpg'
import Barbarossa from '../assets/images/Leaders/FrederickBarbarossa.jpg'
import Genghis from '../assets/images/Leaders/GenghisKhan.jpg'
import Joan from '../assets/images/Leaders/JoanOfArc.jpg'
import DaVinci from '../assets/images/Leaders/LeonardoDaVinci.jpg'
import Michelangelo from '../assets/images/Leaders/Michelangelo.jpg'
import Newton from '../assets/images/Leaders/IsaacNewton.jpg'
import JamesCook from '../assets/images/Leaders/JamesCook.jpg'
import Bach from '../assets/images/Leaders/JohannesSebastianBach.jpg'
import Robespierre from '../assets/images/Leaders/MaximillienRobespierre.jpg'
import Napoleon from '../assets/images/Leaders/NapoleonBonaparte.jpg'
import Shakespeare from '../assets/images/Leaders/WilliamShakespeare.jpg'
import Einstein from '../assets/images/Leaders/AlbertEinstein.jpg'
import BillGates from '../assets/images/Leaders/BillGates.jpg'
import Chaplin from '../assets/images/Leaders/CharlesChaplin.jpg'
import Gandhi from '../assets/images/Leaders/MahatmaGandhi.jpg'
import SidMeier from '../assets/images/Leaders/SidMeier.jpg'
import Churchill from '../assets/images/Leaders/WinstonChurchill.jpg'

import Colossus from '../assets/images/Wonders/Colossus.jpg'
import HangingGardens from '../assets/images/Wonders/HangingGardens.jpg'
import LibraryOfAlexandria from '../assets/images/Wonders/LibraryOfAlexandria.jpg'
import Pyramids from '../assets/images/Wonders/Pyramids.jpg'
import GreatWall from '../assets/images/Wonders/GreatWall.jpg'
import StPetersBasilica from '../assets/images/Wonders/StPetersBasilica.jpg'
import TajMahal from '../assets/images/Wonders/TajMahal.jpg'
import UniversitasCarolina from '../assets/images/Wonders/UniversitasCarolina.jpg'
import EiffelTower from '../assets/images/Wonders/EiffelTower.jpg'
import Kremlin from '../assets/images/Wonders/Kremlin.jpg'
import OceanLiner from '../assets/images/Wonders/OceanLiner.jpg'
import TranscontinentalRailroad from '../assets/images/Wonders/TranscontinentalRailroad.jpg'
import FastFoodChains from '../assets/images/Wonders/FastFoodChains.jpg'
import FirstSpaceFlight from '../assets/images/Wonders/FirstSpaceFlight.jpg'
import Hollywood from '../assets/images/Wonders/Hollywood.jpg'
import Internet from '../assets/images/Wonders/Internet.jpg'

// New Leaders and Wonders (Wikimedia Commons: see assets/images/CREDITS.md)
import Boudica from '../assets/images/Leaders/Boudica.jpg'
import Cleopatra from '../assets/images/Leaders/Cleopatra.jpg'
import Hippocrates from '../assets/images/Leaders/Hippocrates.jpg'
import SunTzu from '../assets/images/Leaders/SunTzu.jpg'
import Confucius from '../assets/images/Leaders/Confucius.jpg'
import Isabella from '../assets/images/Leaders/IsabellaOfCastile.jpg'
import Zizka from '../assets/images/Leaders/JanZizka.jpg'
import Nostradamus from '../assets/images/Leaders/Nostradamus.jpg'
import Gutenberg from '../assets/images/Leaders/JohannesGutenberg.jpg'
import Catherine from '../assets/images/Leaders/CatherineTheGreat.jpg'
import Saladin from '../assets/images/Leaders/Saladin.jpg'
import MariaTheresa from '../assets/images/Leaders/MariaTheresa.jpg'
import Watt from '../assets/images/Leaders/JamesWatt.jpg'
import Nobel from '../assets/images/Leaders/AlfredNobel.jpg'
import Gaudi from '../assets/images/Leaders/AntoniGaudi.jpg'
import Darwin from '../assets/images/Leaders/CharlesDarwin.jpg'
import MarieCurie from '../assets/images/Leaders/MarieCurie.jpg'
import Dietrich from '../assets/images/Leaders/MarleneDietrich.jpg'
import SteveJobs from '../assets/images/Leaders/SteveJobs.jpg'
import Mandela from '../assets/images/Leaders/NelsonMandela.jpg'
import Coubertin from '../assets/images/Leaders/PierreDeCoubertin.jpg'
import Colosseum from '../assets/images/Wonders/Colosseum.jpg'
import RomanRoads from '../assets/images/Wonders/RomanRoads.jpg'
import Stonehenge from '../assets/images/Wonders/Stonehenge.jpg'
import Acropolis from '../assets/images/Wonders/Acropolis.jpg'
import MachuPicchu from '../assets/images/Wonders/MachuPicchu.jpg'
import HimejiCastle from '../assets/images/Wonders/HimejiCastle.jpg'
import ForbiddenCity from '../assets/images/Wonders/ForbiddenCity.jpg'
import SilkRoad from '../assets/images/Wonders/SilkRoad.jpg'
import HarvardCollege from '../assets/images/Wonders/HarvardCollege.jpg'
import SuezCanal from '../assets/images/Wonders/SuezCanal.jpg'
import UnitedNations from '../assets/images/Wonders/UnitedNations.jpg'
import ManhattanProject from '../assets/images/Wonders/ManhattanProject.jpg'
import Ashoka from '../assets/images/Leaders/Ashoka.jpg'
import Eleanor from '../assets/images/Leaders/EleanorOfAquitaine.jpg'
import Fleming from '../assets/images/Leaders/IanFleming.jpg'
import StatueOfLiberty from '../assets/images/Wonders/StatueOfLiberty.jpg'
import LouvreMuseum from '../assets/images/Wonders/LouvreMuseum.jpg'
import EmpireStateBuilding from '../assets/images/Wonders/EmpireStateBuilding.jpg'
import InternationalRedCross from '../assets/images/Wonders/InternationalRedCross.jpg'

const NewIcons = {
    AirForces: NewAirForces, Arena: NewArena, Artillery: NewArtillery, Cavalry: NewCavalry, Civil: NewCivil,
    Construction: NewConstruction, Exploration: NewExploration, Farm: NewFarm, Infantry: NewInfantry, Lab: NewLab,
    Library: NewLibrary, Military: NewMilitary, Mine: NewMine, Temple: NewTemple, Theater: NewTheater,
    BlueCube: NewBlueCube, YellowCube: NewYellowCube, CivilAction: NewCivilAction, Culture: NewCulture,
    ExplorationResource: NewExplorationResource, Food: NewFood, Happiness: NewHappiness, MilitaryAction: NewMilitaryAction,
    MissingCube: NewMissingCube, Resource: NewResource, Science: NewScience, Strength: NewStrength, Home: NewHome,
    Corruption: NewCorruption, Discard: NewDiscard, Unhappy: NewUnhappy,
};

const ImageContext = createContext();

export const ImageProvider = ({ children }) => {
    const [images, setImages] = useState({ 
      AirForces: { src: AirForces, loaded: false },
      Arena: { src: Arena, loaded: false },
      Artillery: { src: Artillery, loaded: false },
      Cavalry: { src: Cavalry, loaded: false },
      Civil: { src: Civil, loaded: false },
      Construction: { src: Construction, loaded: false },
      Exploration: { src: Exploration, loaded: false },
      Farm: { src: Farm, loaded: false },
      Infantry: { src: Infantry, loaded: false },
      Lab: { src: Lab, loaded: false },
      Library: { src: Library, loaded: false },
      Military: { src: Military, loaded: false },
      Mine: { src: Mine, loaded: false },
      Temple: { src: Temple, loaded: false },
      Theater: { src: Theater, loaded: false },
      BlueCube: { src: BlueCube, loaded: false },
      YellowCube: {src: YellowCube, loaded: false},
      CivilAction: { src: CivilAction, loaded: false },
      Culture: { src: Culture, loaded: false },
      ExplorationResource: { src: ExplorationResource, loaded: false },
      Food: { src: Food, loaded: false },
      Happiness: { src: Happiness, loaded: false },
      MilitaryAction: { src: MilitaryAction, loaded: false },
      MissingCube: { src: MissingCube, loaded: false },
      Resource: { src: Resource, loaded: false },
      Science: { src: Science, loaded: false },
      Strength: { src: Strength, loaded: false },
      Home: { src: Home, loaded: false },
      Corruption: { src: Corruption, loaded: false },
      Discard: { src: Discard, loaded: false },
      Unhappy: { src: Unhappy, loaded: false },
      
      Alexander: { src: Alexander, loaded: false },
      Aristotle: { src: Aristotle, loaded: false },
      Hammurabi: { src: Hammurabi, loaded: false },
      Homer: { src: Homer, loaded: false },
      Caesar: { src: Caesar, loaded: false },
      Moses: { src: Moses, loaded: false },
      Columbus: { src: Columbus, loaded: false },
      Barbarossa: { src: Barbarossa, loaded: false },
      Genghis: { src: Genghis, loaded: false },
      Joan: { src: Joan, loaded: false },
      DaVinci: { src: DaVinci, loaded: false },
      Michelangelo: { src: Michelangelo, loaded: false },
      Newton: { src: Newton, loaded: false },
      JamesCook: { src: JamesCook, loaded: false },
      Bach: { src: Bach, loaded: false },
      Robespierre: { src: Robespierre, loaded: false },
      Napoleon: { src: Napoleon, loaded: false },
      Shakespeare: { src: Shakespeare, loaded: false },
      Einstein: { src: Einstein, loaded: false },
      BillGates: { src: BillGates, loaded: false },
      Chaplin: { src: Chaplin, loaded: false },
      Gandhi: { src: Gandhi, loaded: false },
      SidMeier: { src: SidMeier, loaded: false },
      Churchill: { src: Churchill, loaded: false },

      Colossus: { src: Colossus, loaded: false },
      HangingGardens: { src: HangingGardens, loaded: false },
      LibraryOfAlexandria: { src: LibraryOfAlexandria, loaded: false },
      Pyramids: { src: Pyramids, loaded: false },
      GreatWall: { src: GreatWall, loaded: false },
      StPetersBasilica: { src: StPetersBasilica, loaded: false },
      TajMahal: { src: TajMahal, loaded: false },
      UniversitasCarolina: { src: UniversitasCarolina, loaded: false },
      EiffelTower: { src: EiffelTower, loaded: false },
      Kremlin: { src: Kremlin, loaded: false },
      OceanLiner: { src: OceanLiner, loaded: false },
      TranscontinentalRailroad: { src: TranscontinentalRailroad, loaded: false },
      FastFoodChains: { src: FastFoodChains, loaded: false },
      FirstSpaceFlight: { src: FirstSpaceFlight, loaded: false },
      Hollywood: { src: Hollywood, loaded: false },
      Internet: { src: Internet, loaded: false },

      Boudica: { src: Boudica, loaded: false },
      Cleopatra: { src: Cleopatra, loaded: false },
      Hippocrates: { src: Hippocrates, loaded: false },
      SunTzu: { src: SunTzu, loaded: false },
      Confucius: { src: Confucius, loaded: false },
      Isabella: { src: Isabella, loaded: false },
      Zizka: { src: Zizka, loaded: false },
      Nostradamus: { src: Nostradamus, loaded: false },
      Gutenberg: { src: Gutenberg, loaded: false },
      Catherine: { src: Catherine, loaded: false },
      Saladin: { src: Saladin, loaded: false },
      MariaTheresa: { src: MariaTheresa, loaded: false },
      Watt: { src: Watt, loaded: false },
      Nobel: { src: Nobel, loaded: false },
      Gaudi: { src: Gaudi, loaded: false },
      Darwin: { src: Darwin, loaded: false },
      MarieCurie: { src: MarieCurie, loaded: false },
      Dietrich: { src: Dietrich, loaded: false },
      SteveJobs: { src: SteveJobs, loaded: false },
      Mandela: { src: Mandela, loaded: false },
      Coubertin: { src: Coubertin, loaded: false },
      Colosseum: { src: Colosseum, loaded: false },
      RomanRoads: { src: RomanRoads, loaded: false },
      Stonehenge: { src: Stonehenge, loaded: false },
      Acropolis: { src: Acropolis, loaded: false },
      MachuPicchu: { src: MachuPicchu, loaded: false },
      HimejiCastle: { src: HimejiCastle, loaded: false },
      ForbiddenCity: { src: ForbiddenCity, loaded: false },
      SilkRoad: { src: SilkRoad, loaded: false },
      HarvardCollege: { src: HarvardCollege, loaded: false },
      SuezCanal: { src: SuezCanal, loaded: false },
      UnitedNations: { src: UnitedNations, loaded: false },
      ManhattanProject: { src: ManhattanProject, loaded: false },
      Ashoka: { src: Ashoka, loaded: false },
      Eleanor: { src: Eleanor, loaded: false },
      Fleming: { src: Fleming, loaded: false },
      StatueOfLiberty: { src: StatueOfLiberty, loaded: false },
      LouvreMuseum: { src: LouvreMuseum, loaded: false },
      EmpireStateBuilding: { src: EmpireStateBuilding, loaded: false },
      InternationalRedCross: { src: InternationalRedCross, loaded: false },
    });

    const [loading, setLoading] = useState(true);


    useEffect(() => {
      // Get image keys
      const imageKeys = Object.keys(images);
  
      // Preload images
      let loadedCount = 0;
  
      imageKeys.forEach((key) => {
        const img = new Image();
        img.src = images[key].src;
  
        img.onload = () => {
          loadedCount++;
          // Mark the specific image as loaded
          setImages((prev) => ({
            ...prev,
            [key]: { ...prev[key], loaded: true },
          }));
  
          // If all images are loaded, update the loading state
          if (loadedCount === imageKeys.length) {
            setLoading(false);
          }
        };
      });
    }, []);

  // (with "Use new icons", each picture that has a vector drawing shows that instead)
  const [newIcons] = useNewIcons();
  const shown = newIcons
    ? Object.fromEntries(Object.entries(images).map(([key, image]) => [key, NewIcons[key] ? { ...image, src: NewIcons[key] } : image]))
    : images;

  return (
    <ImageContext.Provider value={{ images: shown, loading }}>
      {children}
    </ImageContext.Provider>
  );
};

// Create a custom hook to use the ImageContext
export const useImages = () => {
  return useContext(ImageContext);
};